module.exports = __webpack_public_path__ + "static/img/arrow-down.e17a9b43.svg";